<form #form [attr.id]="formId" action="#" (submit)="onSubmit($event)">
  <ng-content></ng-content>
</form>
